// extracted by mini-css-extract-plugin
export default {"container":"Products_container__CeYBi","products":"Products_products__yfUq7","menu":"Products_menu__pANJJ","list":"Products_list__0aFuX","product":"Products_product__q1bDx"};